export default __webpack_public_path__ + "static/leaves-9f550867908be2feceab3862a2fdd1d0.png";